import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Paragraph } from '@scentregroup/ui'
import Article from '../article'
import Hero from './hero'
import EntryType from './entry-type'
import style from './index.scss'

const IMAGES_TO_DISPLAY = 3

class Accordion extends Component {
  constructor(props) {
    super(props)
    this.state = {
      index: this.props.index,
    }
  }

  activeEntries() {
    return this.props.entries.map(entry => ({
      ...entry,
      active: this.props.entries.indexOf(entry) === this.state.index,
    }))
  }

  entryImages() {
    return this.props.entries
      .map(entry => entry.image)
      .slice(0, IMAGES_TO_DISPLAY)
  }

  setEntry = ref => {
    this.entry = ref
  }

  handleClick = index => {
    this.setState({ index }, () => {
      this.entry.focus()
    })
  }

  render() {
    const { index } = this.state
    const { entries, heading, hasBackground } = this.props

    return (
      <div
        className={classNames(style.Accordion, {
          [style.hasBackground]: hasBackground,
        })}
      >
        <Hero
          images={this.entryImages()}
          hasBackground={hasBackground}
          currentImage={entries[index].imageUrl}
        />
        <div className={style.contentWrapper}>
          <div className={style.entryList}>
            {entries.map((entry, i) => (
              <div
                key={entry.id || entry.slug}
                className={style.entry}
                tabIndex="-1"
                ref={this.setEntry}
              >
                {i === index ? (
                  <Article
                    superheading={heading}
                    heading={entry.title}
                    times={
                      entry.sessions &&
                      entry.sessions[0].name === 'Today' &&
                      entry.sessions[0].sessions.map(s => s.time).join(' | ')
                    }
                    location={entry.location}
                    className={style.entryArticle}
                    link={entry.link}
                    occurrences={entry.occurrences}
                  >
                    <Paragraph type="large">{entry.body}</Paragraph>
                  </Article>
                ) : (
                  <button
                    aria-expanded="false"
                    className={style.entryTitle}
                    onClick={() => this.handleClick(i)}
                  >
                    {entry.title}
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

Accordion.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.shape(EntryType)).isRequired,
  index: PropTypes.number,
  heading: PropTypes.string,
  hasBackground: PropTypes.bool,
}

Accordion.defaultProps = {
  index: 0,
  hasBackground: false,
}

export default Accordion
